export default {
  products: [],
  showProductSelectorDialog: false
}
